import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { ContentBody, Table } from '../../../../core/components'
import { useCustomerLastProducts } from '../../../../services/queries/customer'
import { formatCurrency } from '../../../../utils/format/currencyFormat'
import { dateFormat } from '../../../../utils/format/dateFormat'

export const LastProductsTab = () => {
  const { id }: any = useParams()
  const {
    data: lastProducts,
    error,
    isLoading
  }: any = useCustomerLastProducts({
    page: 1,
    limit: 999,
    id
  })

  const lastProductsColumns = useMemo(
    () => [
      {
        title: 'NF',
        dataIndex: 'nf'
      },
      {
        title: 'Data',
        dataIndex: 'date',
        render: (value: string) => dateFormat(value)
      },
      {
        title: 'Cód Produto',
        dataIndex: 'productId'
      },
      {
        title: 'Produto',
        dataIndex: 'productDescription'
      },
      {
        title: 'Quantidade',
        dataIndex: 'quantity'
      },
      {
        title: 'Valor',
        dataIndex: 'price',
        render: (value: any) => formatCurrency(value)
      },
      {
        title: 'Desconto %',
        dataIndex: 'discount',
        render: (value: any) => value
      },
      {
        title: 'Total',
        dataIndex: 'TOTAL',
        render: (value: any, row: any) =>
          formatCurrency(row?.price * row?.quantity || 0)
      }
    ],
    []
  )

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <>
      <ContentBody>
        <Table
          dataSource={lastProducts?.data || []}
          columns={lastProductsColumns}
          bordered
        />
      </ContentBody>
    </>
  )
}
